import { useCallback, useState } from 'react';

const STORAGE_KEY = 'cc-ws-activity';

/**
 * Activity-rail open/closed state, shared by all five entity workspaces.
 *
 * The default depends on width: at 1280px and up there is room for three
 * columns, so the rail opens; between 1024 and 1279 it starts collapsed so the
 * centre column keeps its width. An explicit choice by the user always wins
 * over that default and persists across records and sessions.
 */
export function useActivityRail(): [boolean, () => void] {
  const [open, setOpen] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored === 'true') return true;
      if (stored === 'false') return false;
    } catch {
      // Unavailable storage just means we fall through to the width default.
    }
    return typeof window === 'undefined' ? true : window.innerWidth >= 1280;
  });

  const toggle = useCallback(() => {
    setOpen((prev) => {
      const next = !prev;
      try { localStorage.setItem(STORAGE_KEY, String(next)); } catch { /* ignore */ }
      return next;
    });
  }, []);

  return [open, toggle];
}
